import { render } from "./QuickNavItem.vue?vue&type=template&id=018d820d"
import script from "./QuickNavItem.vue?vue&type=script&lang=js"
export * from "./QuickNavItem.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__